import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncHostPage = Load(
  () =>
    import(
      /* webpackChunkName: "host-page" */
      './components/HostPage'
    ),
  {},
  true,
);

const AsyncContactHostSuccess = Load(
  () =>
    import(
      /* webpackChunkName: "contact-host-form" */ 'modules/host/containers/ContactHostSuccessContainer'
    ),
  {},
  true,
);
const AsyncContactHostSendingModal = Load(
  () =>
    import(
      /* webpackChunkName: "contact-host-form" */ 'modules/host/containers/ContactHostSendingModalContainer'
    ),
  {},
  true,
);
const AsyncContactHostForm = Load(
  () =>
    import(
      /* webpackChunkName: "contact-host-form" */ 'modules/host/containers/ContactFormContainer'
    ),
  {},
  true,
);
const AsyncExperiencesModal = Load(
  () =>
    import(
      /* webpackChunkName: "experiences-modal" */ './components/HostExperiences/modals/ExperienceModal'
    ),
  {},
  true,
);

const AsyncHostReviewsModal = Load(
  () =>
    import(
      /* webpackChunkName: "host-reviews-modal" */ './containers/HostReviewsModalContainer'
    ),
  {},
  true,
);

const HostRoute = [
  <NavigationableLayout
    key="contact-form-success"
    path={`${basePath}/host/:pretty_url/contact/:form/success`}
    component={AsyncContactHostSuccess}
    hideFooter
  />,
  <Route
    key="contact-form-sending"
    path={`${basePath}/host/:pretty_url/contact/:form/sending`}
    component={AsyncContactHostSendingModal}
  />,
  <NavigationableLayout
    key="contact-form"
    path={`${basePath}/host/:pretty_url/contact/:form`}
    component={AsyncContactHostForm}
    hideFooter
  />,
  <Route
    key="experiences-modal"
    path={`${basePath}/host/:pretty_url/experiences`}
    component={AsyncExperiencesModal}
  />,
  <Route
    key="host-reviews-modal"
    path={`${basePath}/host/:pretty_url/reviews`}
    component={AsyncHostReviewsModal}
  />,
  <NavigationableLayout
    key="host"
    path={`${basePath}/host/:pretty_url`}
    component={AsyncHostPage}
    noNavbar={isCordova()}
  />,
];

export default HostRoute;
